"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Article = void 0;
var uuid_1 = require("uuid");
var constants_1 = require("../constants");
var lib_1 = require("../lib");
var types_1 = require("../types");
var Article = /** @class */ (function () {
    function Article(_a) {
        var cardmarketArticle = _a.cardmarketArticle, attributes = _a.attributes, stockResponseArticle = _a.stockResponseArticle, quantity = _a.quantity, condition = _a.condition, idLanguage = _a.idLanguage, idProduct = _a.idProduct, price = _a.price, comment = _a.comment, location = _a.location, isPlayset = _a.isPlayset, isSigned = _a.isSigned, isFirstEd = _a.isFirstEd, isAltered = _a.isAltered, idArticle = _a.idArticle, finishType = _a.finishType, branded = _a.branded, gradingCompany = _a.gradingCompany, grade = _a.grade, countryEdition = _a.countryEdition, ptArticleId = _a.ptArticleId, buyPrice = _a.buyPrice, standardTaxationQuantity = _a.standardTaxationQuantity, marginTaxationQuantity = _a.marginTaxationQuantity;
        var _b, _c, _d, _e, _f, _g;
        this.branded = undefined;
        if (cardmarketArticle) {
            this.attributes = this.parseCardmarketArticle(cardmarketArticle);
        }
        else if (stockResponseArticle) {
            this.attributes = this.parseStockResponseArticle(stockResponseArticle);
        }
        else if (attributes) {
            this.attributes = attributes;
            this.gradingCompany = gradingCompany !== null && gradingCompany !== void 0 ? gradingCompany : attributes[12];
            this.grade = grade !== null && grade !== void 0 ? grade : attributes[13];
            this.countryEdition = (_b = countryEdition !== null && countryEdition !== void 0 ? countryEdition : attributes[14]) !== null && _b !== void 0 ? _b : constants_1.CountryEdition.Regular;
            this.finishType = (_c = finishType !== null && finishType !== void 0 ? finishType : attributes[15]) !== null && _c !== void 0 ? _c : constants_1.FINISH_TYPE_LABELS.REGULAR;
            this.ptArticleId = (_e = (_d = this.ptArticleId) !== null && _d !== void 0 ? _d : attributes[16]) !== null && _e !== void 0 ? _e : undefined;
            this.buyPrice = (_f = buyPrice) !== null && _f !== void 0 ? _f : undefined;
            this.standardTaxationQuantity = standardTaxationQuantity !== null && standardTaxationQuantity !== void 0 ? standardTaxationQuantity : 0;
            this.marginTaxationQuantity = marginTaxationQuantity !== null && marginTaxationQuantity !== void 0 ? marginTaxationQuantity : 0;
        }
        else if (idProduct) {
            this.attributes = [
                quantity !== null && quantity !== void 0 ? quantity : 1,
                condition !== null && condition !== void 0 ? condition : 'NM',
                idLanguage !== null && idLanguage !== void 0 ? idLanguage : types_1.CardLanguage.English,
                idProduct,
                price !== null && price !== void 0 ? price : 1000,
                comment !== null && comment !== void 0 ? comment : '',
                !!isPlayset,
                !!isSigned,
                !!isFirstEd,
                idArticle !== null && idArticle !== void 0 ? idArticle : '',
                null,
                !!isAltered,
                gradingCompany !== null && gradingCompany !== void 0 ? gradingCompany : undefined,
                grade !== null && grade !== void 0 ? grade : undefined,
                countryEdition !== null && countryEdition !== void 0 ? countryEdition : constants_1.CountryEdition.Regular,
                finishType !== null && finishType !== void 0 ? finishType : constants_1.FINISH_TYPE_LABELS.REGULAR,
                ptArticleId,
            ];
        }
        else {
            throw new Error('invalid data');
        }
        this.quantity = quantity !== null && quantity !== void 0 ? quantity : this.quantity;
        this.condition = condition !== null && condition !== void 0 ? condition : this.condition;
        this.idLanguage = idLanguage !== null && idLanguage !== void 0 ? idLanguage : this.idLanguage;
        this.price = price !== null && price !== void 0 ? price : this.price;
        this.comment = comment !== null && comment !== void 0 ? comment : this.comment;
        this.location = location !== null && location !== void 0 ? location : '';
        this.isPlayset = isPlayset !== null && isPlayset !== void 0 ? isPlayset : this.isPlayset;
        this.isSigned = isSigned !== null && isSigned !== void 0 ? isSigned : this.isSigned;
        this.isFirstEd = isFirstEd !== null && isFirstEd !== void 0 ? isFirstEd : this.isFirstEd;
        this.isAltered = isAltered !== null && isAltered !== void 0 ? isAltered : this.isAltered;
        this.finishType = finishType !== null && finishType !== void 0 ? finishType : this.finishType;
        this.countryEdition = countryEdition !== null && countryEdition !== void 0 ? countryEdition : this.countryEdition;
        this.ptArticleId = ptArticleId !== null && ptArticleId !== void 0 ? ptArticleId : this.ptArticleId;
        this.buyPrice = (_g = buyPrice) !== null && _g !== void 0 ? _g : undefined;
        this.standardTaxationQuantity = standardTaxationQuantity !== null && standardTaxationQuantity !== void 0 ? standardTaxationQuantity : 0;
        this.marginTaxationQuantity = marginTaxationQuantity !== null && marginTaxationQuantity !== void 0 ? marginTaxationQuantity : 0;
        this.idArticle = idArticle !== null && idArticle !== void 0 ? idArticle : this.idArticle;
        this.idArticle = this.idArticle || (0, uuid_1.v4)();
        this.branded = branded;
        if (this.comment.includes('tcgpt') || this.comment.includes('TCGPowerTools')) {
            this.branded = true;
            if (this.comment.includes('|')) {
                this.comment = (0, lib_1.stripBrandingComment)(this.comment);
            }
            else {
                this.comment = '';
            }
        }
    }
    Object.defineProperty(Article.prototype, "quantity", {
        // Getter
        get: function () {
            return this.attributes[0];
        },
        set: function (value) {
            this.attributes[0] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "condition", {
        get: function () {
            return this.attributes[1];
        },
        set: function (value) {
            this.attributes[1] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "idLanguage", {
        get: function () {
            return this.attributes[2];
        },
        set: function (value) {
            this.attributes[2] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "idProduct", {
        get: function () {
            return this.attributes[3];
        },
        set: function (_value) {
            console.log('id product is not settable');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "price", {
        get: function () {
            return Number(this.attributes[4]);
        },
        set: function (value) {
            this.attributes[4] = Number(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "comment", {
        get: function () {
            var _a;
            return (_a = this.attributes[5]) !== null && _a !== void 0 ? _a : '';
        },
        set: function (value) {
            this.attributes[5] = value === null || value === void 0 ? void 0 : value.replace(/\;/g, '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "isPlayset", {
        get: function () {
            return this.attributes[6] || false;
        },
        set: function (value) {
            this.attributes[6] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "isSigned", {
        get: function () {
            return this.attributes[7] || false;
        },
        set: function (value) {
            this.attributes[7] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "isFirstEd", {
        get: function () {
            return this.attributes[8] || false;
        },
        set: function (value) {
            this.attributes[8] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "idArticle", {
        get: function () {
            return this.attributes[9];
        },
        set: function (value) {
            this.attributes[9] = value !== null && value !== void 0 ? value : (0, uuid_1.v4)();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "isAltered", {
        get: function () {
            return this.attributes[11] || false;
        },
        set: function (value) {
            this.attributes[11] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "gradingCompany", {
        get: function () {
            var _a;
            return (_a = this.attributes[12]) !== null && _a !== void 0 ? _a : undefined;
        },
        set: function (value) {
            this.attributes[12] = value !== null && value !== void 0 ? value : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "grade", {
        get: function () {
            var _a;
            return (_a = this.attributes[13]) !== null && _a !== void 0 ? _a : undefined;
        },
        set: function (value) {
            this.attributes[13] = value !== null && value !== void 0 ? value : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "countryEdition", {
        get: function () {
            return this.attributes[14];
        },
        set: function (value) {
            this.attributes[14] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "finishType", {
        get: function () {
            var _a;
            return (_a = this.attributes[15]) !== null && _a !== void 0 ? _a : constants_1.FINISH_TYPE_LABELS.REGULAR;
        },
        set: function (value) {
            this.attributes[15] = value !== null && value !== void 0 ? value : constants_1.FINISH_TYPE_LABELS.REGULAR;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "ptArticleId", {
        get: function () {
            return Number(this.attributes[16]);
        },
        set: function (value) {
            this.attributes[16] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "realComment", {
        get: function () {
            if (this.branded) {
                return (0, lib_1.getBrandedComment)(this.comment);
            }
            else {
                return this.comment.trim() ? this.comment : '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "realAttributes", {
        get: function () {
            var real = __spreadArray([], this.attributes, true);
            real[5] = this.realComment;
            real.push(this.branded);
            return real;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "languageName", {
        get: function () {
            return types_1.CardLanguage[this.idLanguage];
        },
        set: function (value) {
            //@ts-ignore
            var newId = types_1.CardLanguage[value];
            if (!newId) {
                console.log("".concat(value, " not a valid language name"));
            }
            this.attributes[2] = newId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Article.prototype, "isShiny", {
        get: function () {
            return (this.finishType === constants_1.FINISH_TYPE_LABELS.FOIL ||
                this.finishType === constants_1.FINISH_TYPE_LABELS.REVERSE_HOLO);
        },
        enumerable: false,
        configurable: true
    });
    Article.prototype.copy = function () {
        return new Article(__assign({}, this.toPlainObject()));
    };
    Article.prototype.setAttribute = function (attribute /* AttributeName */, value) {
        switch (attribute) {
            case 'quantity':
                if (!Number.isInteger(Number(value)) || Number(value) < 0)
                    console.log('quantity must be a not negative integer');
                else
                    this.quantity = Number(value);
                break;
            case 'idLanguage':
                if (!types_1.CardLanguage[value])
                    console.log('language not recognized');
                else
                    this.idLanguage = value;
                break;
            case 'condition':
                if (!types_1.CARDMARKET_CONDITIONS.find(function (condition) { return condition === value; }))
                    console.log('invalid condition');
                else
                    this.condition = value;
                break;
            case 'price':
                if (Number(value) <= 0)
                    console.log('price must be a positive number');
                else
                    this.price = Number(value);
                break;
            case 'buyPrice':
                if (value === undefined) {
                    this.buyPrice = undefined;
                }
                else if (Number(value) <= 0) {
                    console.log('buy price must be a positive number');
                }
                else {
                    this.buyPrice = Number(value);
                }
                break;
            case 'comment':
                if (!(typeof value === 'string'))
                    console.log('comment must be a string');
                else
                    this.comment = value;
                break;
            case 'location':
                if (!(typeof value === 'string'))
                    console.log('location must be a string');
                else
                    this.location = value;
                break;
            case 'idArticle':
                console.log('idArticle cannot be changed');
                break;
            case 'isPlayset':
                this.isPlayset = !!value;
                break;
            case 'isSigned':
                this.isSigned = !!value;
                break;
            case 'isFirstEd':
                this.isFirstEd = !!value;
                break;
            case 'gradingCompany':
                if (typeof value !== 'string')
                    console.log('gradingCompany must be a string');
                else
                    this.gradingCompany = value;
                break;
            case 'grade':
                this.grade = value;
                break;
            case 'countryEdition':
                this.countryEdition = value;
                break;
            case 'finishType':
                if (typeof value === 'string' &&
                    Object.values(constants_1.FINISH_TYPE_LABELS).includes(value)) {
                    this.finishType = value;
                }
                else {
                    this.finishType = constants_1.FINISH_TYPE_LABELS.REGULAR;
                }
                break;
            default:
                console.log("tried setting invalid attribute \"".concat(attribute, "\" to article"));
        }
    };
    Article.prototype.toPlainObject = function () {
        var _a, _b, _c, _d, _e, _f;
        return {
            quantity: this.quantity,
            condition: this.condition,
            idLanguage: this.idLanguage,
            price: this.price,
            isPlayset: this.isPlayset,
            isFirstEd: this.isFirstEd,
            isSigned: this.isSigned,
            isAltered: this.isAltered,
            comment: this.comment,
            location: this.location,
            idArticle: this.idArticle,
            idProduct: this.idProduct,
            finishType: this.finishType,
            countryEdition: (_a = this.countryEdition) !== null && _a !== void 0 ? _a : constants_1.CountryEdition.Regular,
            gradingCompany: (_b = this.gradingCompany) !== null && _b !== void 0 ? _b : undefined,
            grade: (_c = this.grade) !== null && _c !== void 0 ? _c : undefined,
            ptArticleId: this.ptArticleId,
            buyPrice: (_d = this.buyPrice) !== null && _d !== void 0 ? _d : undefined,
            marginTaxationQuantity: (_e = this.marginTaxationQuantity) !== null && _e !== void 0 ? _e : 0,
            standardTaxationQuantity: (_f = this.standardTaxationQuantity) !== null && _f !== void 0 ? _f : 0,
        };
    };
    //used to discover exactly matching stock while listing
    Article.prototype.isSimilar = function (article) {
        return (this.idProduct === article.idProduct &&
            this.idLanguage === article.idLanguage &&
            this.condition === article.condition &&
            this.isPlayset === article.isPlayset &&
            this.isSigned === article.isSigned &&
            this.isFirstEd === article.isFirstEd &&
            this.countryEdition === article.countryEdition &&
            this.finishType === article.finishType &&
            this.gradingCompany === article.gradingCompany &&
            this.grade === article.grade);
    };
    // Method
    Article.prototype.parseCardmarketArticle = function (cardmarketArticle) {
        var idProduct = cardmarketArticle.idProduct, condition = cardmarketArticle.condition, comments = cardmarketArticle.comments, count = cardmarketArticle.count, price = cardmarketArticle.price, isPlayset = cardmarketArticle.isPlayset, isReverseHolo = cardmarketArticle.isReverseHolo, isFirstEd = cardmarketArticle.isFirstEd, isFoil = cardmarketArticle.isFoil, isSigned = cardmarketArticle.isSigned, isAltered = cardmarketArticle.isAltered, language = cardmarketArticle.language, idArticle = cardmarketArticle.idArticle;
        return [
            Number(count),
            condition,
            Number(language.idLanguage),
            Number(idProduct),
            Number(price),
            comments,
            !!isPlayset,
            !!isSigned,
            !!isFirstEd,
            idArticle,
            null,
            !!isAltered,
            undefined,
            undefined,
            constants_1.CountryEdition.Regular,
            (0, lib_1.getFinishTypeString)(!!isFoil, false, false, !!isReverseHolo),
        ];
    };
    Article.prototype.parseStockResponseArticle = function (stockResponseArticle) {
        var idProduct = stockResponseArticle.idProduct, condition = stockResponseArticle.condition, comments = stockResponseArticle.comments, count = stockResponseArticle.count, price = stockResponseArticle.price, isPlayset = stockResponseArticle.isPlayset, isReverseHolo = stockResponseArticle.isReverseHolo, isFirstEd = stockResponseArticle.isFirstEd, isFoil = stockResponseArticle.isFoil, isSigned = stockResponseArticle.isSigned, isAltered = stockResponseArticle.isAltered, idLanguage = stockResponseArticle.idLanguage, idArticle = stockResponseArticle.idArticle;
        return [
            Number(count),
            condition,
            Number(idLanguage),
            Number(idProduct),
            Number(price),
            comments,
            !!isPlayset,
            !!isSigned,
            !!isFirstEd,
            idArticle,
            null,
            !!isAltered,
            undefined,
            undefined,
            constants_1.CountryEdition.Regular,
            (0, lib_1.getFinishTypeString)(!!isFoil, false, false, !!isReverseHolo),
        ];
    };
    return Article;
}());
exports.Article = Article;
//# sourceMappingURL=Article.js.map